/**
 * Window event fired after this tab changes the multi-product cart (CPS-7479),
 * so cart readers such as the header badge count (useCartCount, CPS-7694) can
 * revalidate without sharing state with the writer.
 */
export const CART_CHANGED_EVENT = 'compass:cart-changed';

/** The single call site writers use after a successful cart change. */
export const notifyCartChanged = (): void => {
  window.dispatchEvent(new Event(CART_CHANGED_EVENT));
};

/** Readers subscribe here; returns the unsubscribe for an effect cleanup. */
export const subscribeToCartChanged = (listener: () => void): (() => void) => {
  window.addEventListener(CART_CHANGED_EVENT, listener);
  return () => window.removeEventListener(CART_CHANGED_EVENT, listener);
};
